import $ from 'jquery'
import Behaviors from './../behaviors'

export default class cannabisProductDeleteAttribute {
    constructor(element) {
        this.$element = $(element)
        this.element = element
        this.targetId = this.element.getAttribute('data-id')
        this.url = this.element.getAttribute('data-url')
        this.element.addEventListener('click', this.handleClick)
    }

    handleClick = (e) => {
        if (e.target.tagName !== 'A' || !e.target.classList.contains('attributeDeleteButton')) {
            return
        }

        e.preventDefault()
        this.handleRemoveAttribute(e.target.getAttribute('href'))
    }

    handleRemoveAttribute(url) {
        $.get(url, function (data, xhr, status) {
            this.handleUpdateContent()
        }.bind(this))
    }

    handleUpdateContent = () => {
        $.get(this.url, function (data, xhr, status) {
            Behaviors.detachBehaviors(this.$element[0])
            this.$element.html($($.parseHTML(data)).find(`table[data-id="${this.targetId}"]`).html())
            this.$element = $(`table[data-id="${this.targetId}"]`)
            if (status === 'error') {
                var msg = 'Sorry but there was an error: '
                this.$target.html(msg + xhr.status + ' ' + xhr.statusText)
            }
            Behaviors.attachBehaviors(this.$element[0])
        }.bind(this))
    }

    destroy() {

    }
}
